import { render, staticRenderFns } from "./AppModuleFormModal.vue?vue&type=template&id=3681d5a2&scoped=true"
import script from "./AppModuleFormModal.vue?vue&type=script&lang=js"
export * from "./AppModuleFormModal.vue?vue&type=script&lang=js"
import style0 from "./AppModuleFormModal.vue?vue&type=style&index=0&id=3681d5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681d5a2",
  null
  
)

export default component.exports